<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Dashboard') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-gray shadow-sm rounded"
                        to="/workspace/admin/settings"
                    >
                        {{ $t('Back') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6">
                <loading :status="loading"/>
                <div class="space-y-6">
                    <div
                        v-for="item in items"
                        :key="item.id"
                        class="shadow sm:rounded sm:overflow-hidden"
                    >
                        <form @submit.prevent="save(item)">
                            <div class="px-4 py-5 bg-white sm:p-6">
                                <div>
                                    <h2 class="text-lg font-semibold text-gray-900">{{ item.name }}</h2>
                                    <p class="mt-1 text-xs text-gray-500">{{ $t('Configure dashboard notice texts by user group') }}</p>
                                </div>

                                <div class="mt-6">
                                    <label class="inline-flex items-center gap-3 text-sm font-medium text-gray-700">
                                        <input
                                            v-model="item.enabled"
                                            class="form-checkbox h-4 w-4 text-green-600 border-gray-300 rounded"
                                            type="checkbox"
                                        >
                                        <span>{{ $t('Enable dashboard hint text') }}</span>
                                    </label>
                                </div>

                                <div class="mt-6">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" :for="'dashboard_notice_' + item.id">
                                        {{ $t('Dashboard hint text') }}
                                    </label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <textarea
                                            :id="'dashboard_notice_' + item.id"
                                            v-model="item.text"
                                            :placeholder="$t('Dashboard hint text')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            rows="5"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="px-4 py-3 stage-footer-surface text-right sm:px-6">
                                <div class="inline-flex">
                                    <button :disabled="savingRoleId === item.id" class="btn btn-green rounded shadow-sm" type="submit">
                                        {{ savingRoleId === item.id ? $t('Loading') : $t('Save settings') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "dashboard-settings",
    data() {
        return {
            loading: true,
            savingRoleId: null,
            items: [],
        };
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            const self = this;
            axios.get('api/workspace/admin/settings/dashboard').then(function (response) {
                self.items = Array.isArray(response.data.items) ? response.data.items : [];
                self.loading = false;
            }).catch(function () {
                self.$router.push('/workspace/admin/settings');
            });
        },
        save(item) {
            const self = this;
            self.savingRoleId = item.id;

            axios.post('api/workspace/admin/settings/dashboard', {
                role_id: item.id,
                enabled: !!item.enabled,
                text: item.text,
            }).then(function (response) {
                const updatedItem = response.data && response.data.item ? response.data.item : null;
                if (updatedItem) {
                    const index = self.items.findIndex((entry) => Number(entry.id) === Number(updatedItem.id));
                    if (index !== -1) {
                        self.items.splice(index, 1, updatedItem);
                    }
                }

                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Settings updated successfully').toString(),
                    type: 'success'
                });
            }).catch(function () {
                // keep local form state so the user can retry
            }).finally(function () {
                self.savingRoleId = null;
            });
        }
    }
}
</script>
